<!-- 巡检任务 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery1">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务名称')">
              <j-input :placeholder="$t('请输入任务名称')" v-model="queryParam.taskName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务状态')">
              <a-select :placeholder="$t('请选择任务状态')" v-model="queryParam.taskState">
                <a-select-option :value="0">{{ $t('未分配') }}</a-select-option>
                <a-select-option :value="1">{{ $t('已分配') }}</a-select-option>
                <a-select-option :value="2">{{ $t('结束') }}</a-select-option>
                <a-select-option :value="3">{{ $t('超时未完成') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('来源')">
              <a-select :placeholder="$t('请选择来源')" v-model="queryParam.source">
                <a-select-option :value="1">{{ $t('水厂') }}</a-select-option>
                <a-select-option :value="2">{{ $t('外围') }}</a-select-option>
                <a-select-option :value="3">{{ $t('营收') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('执行人员类型')">
                <a-select :placeholder="$t('请选择执行人员类型')" v-model="queryParam.taskImplementType">
                  <a-select-option :value="0">{{ $t('班组') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('成员') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="queryParam.taskImplementType == 0||queryParam.taskImplementType == 1">
              <a-form-item :label="$t('执行人员')">
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择执行人员(班组)')" v-model="queryParam.taskImplementName" v-if="queryParam.taskImplementType == 0">
                  <a-select-option :value="item.name" v-for="item in groupList">{{item.name}}</a-select-option>
                </a-select>
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择执行人员(成员)')" v-model="queryParam.taskImplementName" v-if="queryParam.taskImplementType == 1">
                  <a-select-option :value="item.name" v-for="item in personnelList">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('巡检计划')" prop="planId">
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择巡检计划')" v-model="queryParam.planId" @change="planChange">
                  <a-select-option :value="item.id" v-for="item in planList">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('开始时间')">
                <a-date-picker show-time v-model="queryParam.taskBeganTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" :placeholder="$t('请输入开始时间')"/>
              </a-form-model-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('结束时间')">
                <a-date-picker show-time v-model="queryParam.taskEndTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" :placeholder="$t('请输入结束时间')"/>
              </a-form-model-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-model-item :label="$t('创建时间')">
                <!-- <a-date-picker show-time v-model="queryParam.createTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" :placeholder="$t('请输入创建时间')"/> -->
                <a-range-picker v-model="date" format="YYYY-MM-DD" :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                  @change="onDateRangeChange" @ok="onOk" />
              </a-form-model-item>
            </a-col>
          </template>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery1" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset1" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
    </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :customRow="customRow"
        :rowSelection="{type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap "
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="taskState" slot-scope="text, record">
          <a-tag v-if="record.taskState == 0">{{ $t('未分配') }}</a-tag>
          <a-tag color="blue" v-if="record.taskState == 1">{{ $t('已分配') }}</a-tag>
          <a-tag color="red" v-if="record.taskState == 2">{{ $t('结束') }}</a-tag>
          <a-tag color="yellow" v-if="record.taskState == 3">{{ $t('超时未完成') }}</a-tag>
        </template>
        <template slot="planId" slot-scope="text, record">
          {{planList&&planList.find(p=>p.id == text).name}}
        </template>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.taskState == 0">
            <!-- <a @click.stop="handleEdit(record)">{{ $t('编辑') }}</a>
            <a-divider type="vertical"/> -->
            <a @click.stop="handleAssign(record)">{{ $t('分派') }}</a>
            <a-divider type="vertical"/>
          </template>
          <template v-if="record.taskState == 1">
            <a-popconfirm :title="$t('确定结束吗?')" @confirm.stop="() => handleEnd(record)">
              <a>{{ $t('结束') }}</a>
            </a-popconfirm>
            <a-divider type="vertical" />
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click.stop="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm.stop="() => handleDelete1(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <div style="margin-top: 50px;" v-if="dataSource1.length>0">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns1"
        :dataSource="dataSource1"
        :loading="loading"
        :pagination="false"
        class="j-table-force-nowrap "
        @change="handleTableChange">
        <template slot="inspectionTaksRouteDeviceFilePath1" slot-scope="text,record">
          <div style="display: flex;align-items: center;">
            <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==1">
              <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
              <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
            </div>
          </div>
        </template>
        <template slot="inspectionTaksRouteDeviceFilePath2" slot-scope="text,record">
          <div style="display: flex;align-items: center;">
            <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==2">
              <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
              <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
            </div>
          </div>
        </template>
        <template v-for="col in ['isOk', 'resultDescription']" :slot="col" slot-scope="text, record, index">
          <div :key="col">
            <template v-if="record.editable">
              <a-select :placeholder="$t('请选择是否正常')" style="width: 200px;" v-model="text"  @change="e => handleChange1(e, record.id, col)" v-if="col == 'isOk'">
                <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                <a-select-option :value="1">{{ $t('异常') }}</a-select-option>
              </a-select>
              <a-input :placeholder="$t('请输入结果描述')" v-model="text" @change="e => handleChange2(e.target.value, record.id, col)" v-if="col == 'resultDescription'"></a-input>
            </template>
            <template v-else>
              <span v-if="col == 'isOk'">{{text == 0?$t('正常'):text == 1?$t('异常'):''}}</span>
              <span v-else>{{ text }}</span>
            </template>
          </div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail1(record)" v-if="columns_visible">{{ $t('详情') }}</a>
          <template v-else>
            <span v-if="record.editable">
              <a @click="() => handleSave(record.id)">{{ $t('保存') }}</a>
              <a-divider type="vertical" />
              <a @click="() => handleCancel(record.id)">{{ $t('取消') }}</a>
            </span>
            <span v-else>
              <a :disabled="editingKey !== ''" @click="() => handleEdit1(record.id)" id="updateA">{{ $t('更新设备状态') }}</a>
            </span>
          </template>
        </span>
      </a-table>
    </div>
    <inspectionTasksModal ref="modalForm" @ok="loadData"></inspectionTasksModal>
    <inspectionTasksDetailModal ref="detailForm" @ok="loadData"></inspectionTasksDetailModal>
    <inspectionTaskAssignModal ref="assignForm" @ok="loadData"></inspectionTaskAssignModal>
    <inspectionTaskUpdateModal ref="updateForm" @ok="loadData"></inspectionTaskUpdateModal>
    <deviceModal ref="deviceForm"></deviceModal>
    <!-- <j-modal :title="$t('预览')" :width="348" :visible="visiblePirture" :maskClosable="false" @cancel="imghandleCancel" :okButtonProps="{ class:{'jee-hidden': true} }">
      <img :src="viewUrl" alt="" style="width: 300px;height: 300px;"/>
    </j-modal> -->
    <a-modal :title="$t('预览')" :width="700" :visible="visiblePirture" :footer="null" @cancel="imghandleCancel">
      <img alt="example" style="width: 100%;height: 100%;" :src="viewUrl.url" v-if="viewUrl.fileType == 'image'"/>
      <video controls :src="viewUrl.url" style="width: 100%;height: 100%;" v-if="viewUrl.fileType == 'video'"></video>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import inspectionTasksModal from './modules/inspectionTasksModal'
  import inspectionTasksDetailModal from './modules/inspectionTasksDetailModal'
  import inspectionTaskAssignModal from './modules/inspectionTaskAssignModal'
  import inspectionTaskUpdateModal from './modules/inspectionTaskUpdateModal'
  import deviceModal from '../deviceManagement/modules/deviceModal'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'inspectionTasks',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      inspectionTasksModal,
      inspectionTasksDetailModal,
      inspectionTaskAssignModal,
      inspectionTaskUpdateModal,
      deviceModal,
      JInput
    },
    data () {
      return {
        // 表头

        url: {
          list: "/jeecg-engineering/inspection/inspectionTask/list",
          delete: "/jeecg-engineering/inspection/inspectionTask/delete",
          deleteBatch: "/jeecg-engineering/inspection/inspectionTask/deleteBatch",
          exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
          importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
          editState: "/jeecg-engineering/inspection/inspectionTask/editState",
          queryTableById: "/jeecg-engineering/inspection/inspectionTask/queryTableById",
          editUpdateState: "/jeecg-engineering/inspection/InspectionTaskRouteDevice/editUpdateState",
          inspectionTeam: "/jeecg-engineering/engineering/inspectionTeam/list",
          inspectionUser: "/jeecg-engineering/inspection/inspectionUser/list",
          inspectionPlan: "/jeecg-engineering/inspection/inspectionPlan/list",
        },
        dictOptions:{},
        superFieldList:[],
        // 表头



        dataSource1:[],
        queryParam:{},
        editingKey: '',
        cacheData:[],
        columns_visible: false,
        visiblePirture: false,
        viewUrl: {},
        groupList: [],
        personnelList: [],
        planList: [],
      }
    },
    created() {
      this.getPersonnelList();
      this.getDeptList();
      this.getplanList();
    },
    computed: {
      description() {
        return this.$t('巡检任务页面')
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          // {
          //   title: this.$t('任务单号'),
          //   align:"center",
          //   dataIndex: 'taskNum'
          // },
          {
            title: this.$t('任务名称'),
            align:"center",
            dataIndex: 'taskName'
          },
          {
            title: this.$t('任务类型'),
            align:"center",
            dataIndex: 'taskCategory',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('临时任务');
              }else if(t == 1){
                return this.$t('日常任务');
              }
            }
          },
          {
            title: this.$t('巡检计划'),
            align:"center",
            dataIndex: 'planName',
            // scopedSlots: { customRender: 'planId' },
          },
          {
            title: this.$t('任务状态'),
            align:"center",
            dataIndex: 'taskState',
            scopedSlots: { customRender: 'taskState' },
            // customRender: (t,r,index) => {
            //   if(t == 0){
            //     return this.$t('未分配');
            //   }else if(t == 1){
            //     return this.$t('已分配');
            //   }else{
            //     return this.$t('结束');
            //   }
            // }
          },
          {
            title: this.$t('巡检状态'),
            align:"center",
            dataIndex: 'task',
            customRender: (t,r,index) => {
              if(r.taskState==0){
                return this.$t('未开始');
              }else if(r.taskState==1){
                return this.$t('进行中');
              }else if(r.taskState==2){
                return this.$t('已完成');
              }else {
                return this.$t('未完成');
              }
            }
          },
          {
            title: this.$t('开始时间'),
            align:"center",
            dataIndex: 'taskBeganTime'
          },
          {
            title: this.$t('结束时间'),
            align:"center",
            dataIndex: 'taskEndTime'
          },
          {
            title: this.$t('执行人员类型'),
            align:"center",
            dataIndex: 'taskImplementType',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('班组');
              }else if(t == 1){
                return this.$t('成员');
              }
            }
          },
          {
            title: this.$t('执行人员(班组/成员)'),
            align:"center",
            dataIndex: 'taskImplementName'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:160,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      columns1() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName',
            ellipsis:true
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis:true
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (t,r,indnx) => {
              return filterDictTextByCache('deviceType',t)
            }
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis:true
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude'
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude'
          },
          {
            title: this.$t('是否存在问题'),
            align: "center",
            dataIndex: 'abnormalOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('是');
              } else if (t == 2) {
                return this.$t('否');
              }
            }
          },
          {
            title: this.$t('运行状态'),
            align: "center",
            dataIndex: 'runOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('正常');
              } else if (t == 2) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('问题描述'),
            align: "center",
            dataIndex: 'exceptionDescription',
            // width: 300,
            ellipsis: true,
          },
          {
            title: this.$t('巡检结果'),
            align: "center",
            dataIndex: 'isOk',
            customRender: (t, r, index) => {
              if (t == 0) {
                return this.$t('正常');
              } else if (t == 1) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('解决前照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath1'
            },
            // width: 300
          },
          {
            title: this.$t('解决后照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath2'
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      columns_0() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName',
            ellipsis:true
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis:true
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            }
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis:true
          },
          // {
          //   title: this.$t('设备经度'),
          //   align:"center",
          //   dataIndex: 'detectLongitude'
          // },
          // {
          //   title: this.$t('设备纬度'),
          //   align:"center",
          //   dataIndex: 'detectLatitude'
          // },
          // {
          //   title: this.$t('备注'),
          //   align:"center",
          //   dataIndex: 'remark'
          // },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      columns_1() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName',
            ellipsis:true
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis:true
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            }
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis:true
          },
          {
            title: this.$t('是否存在问题'),
            align: "center",
            dataIndex: 'abnormalOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('是');
              } else if (t == 2) {
                return this.$t('否');
              }
            }
          },
          {
            title: this.$t('运行状态'),
            align: "center",
            dataIndex: 'runOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('正常');
              } else if (t == 2) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('问题描述'),
            align: "center",
            dataIndex: 'exceptionDescription',
            // width: 300,
            ellipsis: true,
          },
          {
            title: this.$t('巡检结果'),
            align: "center",
            dataIndex: 'isOk',
            customRender: (t, r, index) => {
              if (t == 0) {
                return this.$t('正常');
              } else if (t == 1) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('解决前照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath1'
            },
            width: 200
          },
          {
            title: this.$t('解决后照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath2'
            },
            width: 200
          },
          {
            title: this.$t('操作人'),
            align: "center",
            dataIndex: 'updateBy',
          },
          {
            title: this.$t('操作时间'),
            align: "center",
            dataIndex: 'updateTime',
            width: 150,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    watch:{
      'queryParam.taskState':{
        handler(val){
          this.dataSource1 = [];
        }
      }
    },
    methods: {
      searchQuery1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchQuery()
      },
      searchReset1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchReset()
      },
      searchReset(){
        this.queryParam = {};
        this.loadData(1);
      },
      handleDelete1(id){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.handleDelete(id)
      },
      getplanList() {
        this.planList = [];
        getAction(this.url.inspectionPlan,{pageSize:999,order: 'desc',column: 'createTime'}).then(res => {
          if (res.success) {
            res.result.records.forEach(item => {
              if(item.planState == 0){
                this.planList.push({
                  name:item.planName,
                  id:item.id
                });
              }
            });
          }
        });
      },
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.inspectionUser,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                id: item.userId,
                name: item.userName
              });
            });
          }
        });
      },
      getDeptList(){
        this.groupList = [];
        getAction(this.url.inspectionTeam,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.groupList.push({
                id: item.id,
                name: item.teamName
              });
            });
          }
        })
      },
      // 详情
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.detailForm.init(row);
        })
      },
      // 分派
      handleAssign(row){
        this.$nextTick(()=>{
          this.$refs.assignForm.init(row);
        })
      },
      // 更新任务
      handleUpdate(row){
        this.$nextTick(()=>{
          this.$refs.updateForm.init(row);
        })
      },
      // 结束任务
      handleEnd(row){
        this.loading = true;
        postAction(this.url.editState,row).then(res=>{
          if(res.success){
            this.$message.success(res.message);
            this.loading = false;
            this.loadData();
            this.selectedRowKeys = [];
            this.dataSource1 = [];
          }else{
            this.$message.warning(res.message)
            this.loading = false;
          }
        })
      },
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        if (this.selectedRowKeys.length == 0) {
          this.dataSource1 = []
          return;
        }
        if(selectionRows[0].taskState == 0){
          this.columns1 = this.columns_0;
          this.columns_visible = true;
        }else if(selectionRows[0].taskState == 2){
          this.columns1 = this.columns_1;
          this.columns_visible = true;
        }else if(selectionRows[0].taskState == 3){
          this.columns1 = this.columns_1;
          this.columns_visible = true;
        }else{
          this.columns1 = this.columns_1;
          this.columns_visible = true;
        }
        getAction(this.url.queryTableById,{id:selectedRowKeys[0]}).then(res=>{
          if(res.success){
            this.dataSource1 = res.result;
            this.cacheData = this.dataSource1.map(item => ({ ...item }));
            this.editingKey = '';
          }
        })
      },
      customRow (record, index) {
        return {
          on:{
            click:(e)=>{
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
              let selectionRows = this.dataSource.filter(d=>d.id == e.currentTarget.dataset.rowKey);
              if(selectionRows[0].taskState == 0){
                this.columns1 = this.columns_0;
                this.columns_visible = true;
              }else if(selectionRows[0].taskState == 2){
                this.columns1 = this.columns_1;
                this.columns_visible = true;
              }else if(selectionRows[0].taskState == 3){
                this.columns1 = this.columns_1;
                this.columns_visible = true;
              }else{
                this.columns1 = this.columns_1;
                this.columns_visible = true;
              }
              getAction(this.url.queryTableById,{id:e.currentTarget.dataset.rowKey}).then(res=>{
                if(res.success){
                  this.dataSource1 = res.result;
                  this.cacheData = this.dataSource1.map(item => ({ ...item }));
                  this.editingKey = '';
                }
              })
            }
          }
        }
      },
      handleDetail1(row){
        this.$refs.deviceForm.edit({...row,id:row.deviceId});
        this.$refs.deviceForm.title = this.$t('详情');
        this.$refs.deviceForm.disableSubmit = true;
      },
      handleEdit1(key){
        const newData = [...this.dataSource1];
        const target = newData.find(item => key === item.id);
        this.editingKey = key;
        if (target) {
          target.editable = true;
          this.dataSource1 = newData;
        } else {
          target.editable = false;
        }
      },
      handleSave(key){
        let that = this;
        const newData = [...this.dataSource1];
        const newCacheData = [...this.cacheData];
        const target = newData.find(item => key === item.id);
        const targetCache = newCacheData.find(item => key === item.id);
        if (target && targetCache) {
          delete target.editable;
          this.dataSource1 = newData;
          Object.assign(targetCache, target);
          this.cacheData = newCacheData;
        }
        this.editingKey = '';
        postAction(this.url.editUpdateState,target).then(res=>{
          if(res.success){
            this.$message.success(res.message);
            getAction(that.url.queryTableById, {
              id: that.selectedRowKeys[0]
            }).then(res => {
              if (res.success) {
                that.dataSource1 = res.result;
                that.cacheData = that.dataSource1.map(item => ({ ...item }));
              }
            })
          }else{
            // this.handleChange1(null,key,'isOk');
            // this.handleChange2('',key,'resultDescription');
            this.$message.warning(res.message);
          }
        });
        this.dataSource1
      },
      handleCancel(key){
        const newData = [...this.dataSource1];
        const target = newData.find(item => key === item.id);
        this.editingKey = '';
        if (target) {
          Object.assign(target, this.cacheData.find(item => key === item.id));
          delete target.editable;
          this.dataSource1 = newData;
        }
      },
      handleChange1(value, key, column) {
        const newData = [...this.dataSource1];
        const target = newData.find(item => key === item.id);
        if (target) {
          target[column] = value;
          this.dataSource1 = newData;
        }
      },
      handleChange2(value, key, column) {
        const newData = [...this.dataSource1];
        const target = newData.find(item => key === item.id);
        if (target) {
          target[column] = value;
          this.dataSource1 = newData;
        }
      },
      setSrc(url){
        if(url){
          return window._CONFIG['domianURL']+'/sys/common/static/'+url;
        }
      },
      // 预览图片
      viewPicture(item){
        this.visiblePirture = true;
        this.viewUrl = item;
      },
      imghandleCancel(){
        this.visiblePirture = false;
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
        this.selectedRowKeys = [];
        this.dataSource1 = [];
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .ant-table-thead{
    position: sticky;
    top: 0;
    z-index: 1;
  }
  /deep/ .ant-table-body{
    overflow-y: scroll;
    max-height: 450px;
  }
</style>